// utils/validators.js

export const validateNationalCode = (code) => {
  if (!/^\d{10}$/.test(code)) return false;

  const check = Number(code[9]);

  let sum = 0;

  for (let i = 0; i < 9; i++) {
    sum += Number(code[i]) * (10 - i);
  }

  const remainder = sum % 11;

  return remainder < 2 ? check === remainder : check === 11 - remainder;
};

export const phoneValidator = /^0\d{10}$/;

export const postalValidator = /^\d{10}$/;
